/**
 * PlotsPanel - Container that provides plot data to PlotDataPanelContainer.
 *
 * This component reads plots from the session store and passes them
 * to the PlotDataPanelContainer which handles the remaining store access.
 */

import React from 'react';
import { useSessionData } from '../../../../hooks/useSessionData';
import PlotDataPanelContainer from './PlotDataPanelContainer';

const PlotsPanel: React.FC = () => {
  const plots = useSessionData(session => session.plots.plots, []);
  return (
    <PlotDataPanelContainer plots={plots} />
  );
};

export default PlotsPanel;